import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

var EntryCard = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-EntryCard',
	};

	$.extend(true, this.options, options);

};

EntryCard.prototype.init = function() {

	var self = this;

	// gsap.to(self.options.$el.find(`.${self.options.baseClass}__cardHeading__line`), {
	// 	scrollTrigger: {
	// 		trigger: self.options.$el,
	// 		start: "bottom bottom",
	// 		end: "top top"
	// 	},
	// 	right: "0%",
	// 	duration: 1,
	// 	ease: "power1.out"
	// });

	// gsap.to(self.options.$el, {
	// 	scrollTrigger: {
	// 		trigger: self.options.$el,
	// 		start: "top bottom-=20px",
	// 		// markers: true,
	// 	},
	// 	y: 0,
	// 	opacity: 1,
	// 	duration: 0.8,
	// 	ease: "power3.out"
	// });

};

export default EntryCard;
